module.exports = __webpack_public_path__ + "static/presidents-message-79a2d62be10adcecd14154a581b5e414.jpg";